<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    :maskClosable="maskClosable"
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <meter-Activate-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></meter-Activate-form>
  </j-modal>
</template>

<script>
  import MeterActivateForm from './MeterActivateForm'
  export default {
    name: 'MeterActivateModal',
    components: {
      MeterActivateForm
    },
    data () {
      return {
        title:'',
        width:900,
        visible: false,
        disableSubmit: false,
        maskClosable: false
      }
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(row){
        this.$emit('ok',row);
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>